const totalFormat = { totalActivityCount: 0, totalHours: 0, totalStaff: 0 };
const initialTotals = Array.from(Array(7)).map(() => ({ ...totalFormat }));
const initialTotalsObj = {};
for (let i = 0; i < initialTotals.length; ++i) {
  initialTotalsObj[`day${i + 1}`] = initialTotals[i];
}
initialTotalsObj['weekTotal']=initialTotals[0];

const defProductHours = "7.5";
const defAPHTarget = 100;
const initialDaysData = {
  day1: { enabled: false },
  day2: { enabled: true },
  day3: { enabled: true },
  day4: { enabled: true },
  day5: { enabled: true },
  day6: { enabled: true },
  day7: { enabled: false },
};

const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
].map((e) => e.toUpperCase());

const initialSelections = {
  district: "",
  buildings: [],
  week: "",
  averageBy: "",
};

export {
  initialTotals,
  initialTotalsObj,
  days,
  initialSelections,
  initialDaysData,
  defProductHours,
  defAPHTarget
};
